// Hero
window.addEventListener("load", function(){
    $('.hero_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 900,
    infinite: true,
    lazyLoad: false,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100
    });
});

// Luxury
// var $slider = $(".luxury_slider");
// var $progressBar = $(".slider-progress .progress");

// $slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
//     var calc = ( (nextSlide+1) / slick.slideCount ) * 100;
//     $progressBar.css("width", calc + "%");
// });

// $slider.slick({
//     dots: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     slidesToShow: 4,
//     arrows: true,
//     centerMode: false,
// 	  responsive: [
//         {
//         breakpoint: 1440,
//             settings: { slidesToShow: 4 }
//         },
//         {
//         breakpoint: 1200,
//             settings: { slidesToShow: 3 }
//         },
//         {
//         breakpoint: 768,
//             settings: { slidesToShow: 2 }
//         },
//         {
//         breakpoint: 576,
//             settings: { slidesToShow: 1, slidesToScroll: 1 }
//         }
//     ]
// });

document.addEventListener('DOMContentLoaded', function () {

  const wrapper = document.querySelector('.luxury_slider_wrapper');

  new Swiper(wrapper.querySelector('.luxury_slider'), {

    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 800,

    navigation: {
      nextEl: wrapper.querySelector('.luxury_slider-next'),
      prevEl: wrapper.querySelector('.luxury_slider-prev'),
    },

    pagination: {
      el: wrapper.querySelector('.luxury_slider-pagination'),
      type: 'progressbar'
    },

    breakpoints: {
    576: {
        slidesPerView: 2
    },
    768: {
        slidesPerView: 2
    },
    991: {
        slidesPerView: 3
    },
    1200: {
        slidesPerView: 4
    }
    }

  });

});

// Glow
window.addEventListener("load", function(){
    $('.glow_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 900,
    infinite: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100
    });
});

// Review
var $slider = $(".review_slider");
var $progressBar = $(".slider-progress .progress");

$slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
    var calc = ( (nextSlide+1) / slick.slideCount ) * 100;
    $progressBar.css("width", calc + "%");
});

$slider.slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    arrows: true,
    centerMode: false,
	  responsive: [
        {
        breakpoint: 1580,
            settings: { slidesToShow: 2 }
        },
        {
        breakpoint: 992,
            settings: { slidesToShow: 1 }
        },
        {
        breakpoint: 576,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
    ]
});

// Collapse
const leftImage = document.getElementById('left-info-image');

document.querySelectorAll('.accordian .heading').forEach((heading) => {
    heading.addEventListener('click', function () {

        const accordion = this.parentElement;
        const content = accordion.querySelector('.content');
        const wrapper = accordion.parentElement;

        // Close other accordions
        wrapper.querySelectorAll('.accordian').forEach((item) => {
            if (item !== accordion) {
                item.classList.remove('active');
                item.querySelector('.content').style.maxHeight = null;
            }
        });

        // Toggle current
        accordion.classList.toggle('active');

        if (accordion.classList.contains('active')) {
            content.style.maxHeight = content.scrollHeight + "px";

            // Change left_info image
            const newImg = accordion.getAttribute('data-image');
            if (newImg) {
                leftImage.setAttribute('src', newImg);
            }

        } else {
            content.style.maxHeight = null;
        }
    });
});

// Default open accordion height + image
const firstAcc = document.querySelector('.accordian.active');
if (firstAcc) {
    const firstContent = firstAcc.querySelector('.content');
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";

    const defaultImg = firstAcc.getAttribute('data-image');
    if (defaultImg) {
        leftImage.setAttribute('src', defaultImg);
    }
}

// Table Split Start
document.addEventListener("DOMContentLoaded", function () {

  // HEAD
  const headEl = document.querySelector(".chart-head");
  if (headEl) {
    const html = headEl.innerHTML;
    const cols = html.split("|");
    const headRow = document.getElementById("chart-head");

    cols.forEach(col => {
      const th = document.createElement("th");
      th.innerHTML = col.trim();
      headRow.appendChild(th);
    });
  }

  // BODY ROWS
  const rows = document.querySelectorAll(".chart-row");
  const tbody = document.getElementById("chart-body");

  rows.forEach(rowEl => {
    const html = rowEl.innerHTML;
    const cols = html.split("|");
    const tr = document.createElement("tr");

    cols.forEach(col => {
      const td = document.createElement("td");
      td.innerHTML = col.trim();
      tr.appendChild(td);
    });

    tbody.appendChild(tr);
  });

});
// Table Split END

// Routin Section
jQuery(".routine-pairing-anim-items .routine-pairing-center-num span.num:first-child, .routine-pairing-anim-items .routine-pairing-center-block:first-child, .routine-pairing-anim-items .routine-pairing-bg-block:first-child").addClass("active");
jQuery(document).ready(function() {
	jQuery(".routine-pairing-anim-items .routine-pairing-center-num span.num").mouseover(function(event){
		event.preventDefault();
		jQuery(".routine-pairing-anim-items .routine-pairing-center-num span.num, .routine-pairing-anim-items .routine-pairing-center-block, .routine-pairing-anim-items .routine-pairing-bg-block").removeClass("active");
		jQuery("."+jQuery(this).attr("rel")).addClass("active");
		jQuery(this).addClass("active");
	});
});
// Routin Section END


jQuery(document).ready(function (jQuery) {
    if (jQuery('.cart-upsell-block .cart-upsell-row').children().length === 0) {
        jQuery('.cart-upsell-block').hide();
    }
});



jQuery(document).ready(function() {
    jQuery('.beaf-main-slider').slick({
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

// Amino Smarter Facial Section Start
document.querySelectorAll('.smarter_sec .smart_block .plus_ic').forEach(button => {
    button.addEventListener('click', function(){
        const currentBlock = this.closest('.smart_block');
        document.querySelectorAll('.smarter_sec .smart_block')
        .forEach(block => {
            if(block !== currentBlock){
                block.classList.remove('active');
            }
        });
        currentBlock.classList.toggle('active');
    });
});
// Amino Smarter Facial Section END

// Clean Section Change image and show content
var checkavailable = document.querySelector(".clean_sec");
if (checkavailable) {
    const cleanSection = document.querySelector('.clean_sec');
const inner = cleanSection.querySelector('.clean_wrap');

const details = cleanSection.querySelectorAll('.detail');
const figures = cleanSection.querySelectorAll('.right_info figure');

const totalItems = details.length;

const sectionScroll = window.innerHeight * (totalItems - 1) + window.innerHeight;

cleanSection.style.height = sectionScroll + 'px';

function updateActive() {

    const sectionTop = cleanSection.offsetTop;
    const sectionHeight = cleanSection.offsetHeight;
    const scrollY = window.scrollY;

    // STICKY START
    if (
        scrollY >= sectionTop &&
        scrollY <= sectionTop + sectionHeight - window.innerHeight
    ) {

        inner.style.position = 'fixed';
        inner.style.top = '0';
        inner.style.left = cleanSection.getBoundingClientRect().left + 'px';
        inner.style.width = cleanSection.offsetWidth + 'px';
        inner.style.height = '100vh';

    } else {

        inner.style.position = 'relative';
        inner.style.top = 'unset';
        inner.style.left = 'unset';
        inner.style.width = '100%';
        inner.style.height = 'auto';
    }

    // END POSITION
    if (scrollY > sectionTop + sectionHeight - window.innerHeight) {

        inner.style.position = 'relative';
        inner.style.top = sectionHeight - window.innerHeight + 'px';
        inner.style.left = '0';
        inner.style.width = '100%';
    }

    // ACTIVE ITEM
    let progress = scrollY - sectionTop;

    progress = Math.max(0, progress);

    // EACH SCREEN = NEXT ITEM
    const activeIndex = Math.min(
        totalItems - 1,
        Math.floor((progress + window.innerHeight * 0.5) / window.innerHeight)
    );

    details.forEach(detail => {
        detail.classList.remove('active');
    });

    figures.forEach(figure => {
        figure.classList.remove('active');
    });

    const currentId = details[activeIndex].getAttribute('data-id');

    details[activeIndex].classList.add('active');

    cleanSection
        .querySelector(`figure[data-id="${currentId}"]`)
        .classList.add('active');
}

window.addEventListener('scroll', updateActive);
updateActive();
}
// Clean Section Change image and show content END

// Landing Page Start
var checkavailable = document.querySelector(".hydration_sec");
if (checkavailable) {
const hydrationSection = document.querySelector('.hydration_sec');
const hydrationWrap = hydrationSection.querySelector('.hydration_wrap');
const hydrationInfo = hydrationSection.querySelector('.hydration_info');
const hydrationInner = hydrationSection.querySelector('.hydration_inner');

function setSpacing() {

    const infoHeight = hydrationInfo.clientHeight;

    hydrationInner.style.paddingTop = infoHeight + 'px';
    hydrationInner.style.paddingBottom = infoHeight + 'px';
}

setSpacing();

let innerScroll =
    hydrationInfo.scrollHeight - hydrationInfo.clientHeight;

hydrationSection.style.height =
    window.innerHeight + innerScroll + 'px';

const wrapInitialTop =
    hydrationWrap.offsetTop + hydrationSection.offsetTop;

function hydrationScroll() {

    innerScroll =
        hydrationInfo.scrollHeight - hydrationInfo.clientHeight;

    const sectionTop = hydrationSection.offsetTop;
    const sectionHeight = hydrationSection.offsetHeight;

    const scrollY = window.scrollY;

    // UPDATED
    const start = scrollY >= wrapInitialTop;

    const end =
        scrollY <= sectionTop + sectionHeight - window.innerHeight;

    if (start && end) {

        hydrationWrap.style.position = 'fixed';
        hydrationWrap.style.top = '0';

        hydrationWrap.style.left =
            hydrationSection.getBoundingClientRect().left + 'px';

        hydrationWrap.style.width =
            hydrationSection.offsetWidth + 'px';

        hydrationWrap.style.height = '100vh';

        hydrationWrap.style.background = '#F6EEE9';

    } else {

        hydrationWrap.style.position = 'relative';
        hydrationWrap.style.top = 'unset';
        hydrationWrap.style.left = 'unset';
        hydrationWrap.style.width = '100%';
        hydrationWrap.style.height = 'auto';
    }

    if (scrollY > sectionTop + sectionHeight - window.innerHeight) {

        const hydrationStyles =
            window.getComputedStyle(hydrationSection);

        const paddingTop =
            parseFloat(hydrationStyles.paddingTop);

        const paddingBottom =
            parseFloat(hydrationStyles.paddingBottom);

        const totalPadding =
            paddingTop + paddingBottom;

        hydrationWrap.style.position = 'relative';

        hydrationWrap.style.top =
            sectionHeight -
            window.innerHeight -
            document.querySelector('.skin-top-content').offsetHeight -
            totalPadding + 'px';

        hydrationWrap.style.left = '0';

        hydrationWrap.style.width = '100%';
    }

    let progress = scrollY - sectionTop;

    progress = Math.max(0, progress);
    progress = Math.min(progress, innerScroll);

    hydrationInfo.scrollTop = progress;
}

window.addEventListener('scroll', hydrationScroll);

window.addEventListener('resize', () => {

    setSpacing();

    innerScroll =
        hydrationInfo.scrollHeight - hydrationInfo.clientHeight;

    hydrationSection.style.height =
        window.innerHeight + innerScroll + 'px';

    hydrationScroll();
});

hydrationScroll();
}
// Landing Page END

// Beaty Slider Landing Page Start
document.addEventListener("DOMContentLoaded", function () {
    const beautySection = document.querySelector('.beauty_sec');
    if (!beautySection) return;

    const variantInput = beautySection.querySelector('.variant_id');
    const submitBtn = beautySection.querySelector('.product-form__submit');
    const btnText = beautySection.querySelector('.btn_text');
    const productImage = beautySection.querySelector('.product_img img');

    let isDragging = false;
    const progressBar = beautySection.querySelector('.swiper-scrollbar');
    const dragEl = beautySection.querySelector('.swiper-scrollbar .drag');

    function updateProgress(swiper) {
        if (!progressBar || !dragEl) return;

        const barWidth = progressBar.clientWidth;
        const dragWidth = dragEl.clientWidth;
        const maxTravel = barWidth - dragWidth; 

        const realTotal = swiper.slides.length; 
        let index = swiper.realIndex;

        const progress = realTotal <= 1 ? 0 : index / (realTotal - 1);

        dragEl.style.left = `${progress * maxTravel}px`;
    }

    /* ---------------------------
       SWIPER INITIALIZATION
    ---------------------------- */
    var navSwiper = new Swiper('.nav-slider', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        allowTouchMove: false,
    });

    var mainSwiper = new Swiper('.main-slider', {
        slidesPerView: 3,
        centeredSlides: true,
        loop: true,
        thumbs: {
            swiper: navSwiper,
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
            },

            576: {
                slidesPerView: 1.6,
            },

            768: {
                slidesPerView: 2,
            },

            1200: {
                slidesPerView: 3,
            }

        },

        on: {
            init: function () {
                updateProgress(this);
            },
            slideChange: function () {
                updateProgress(this);
                updateProductData(this);
            },
            resize: function () {
                updateProgress(this);
            }
        }
    });

    function updateProductData(swiperInstance) {
        let activeSlide;
        
        if (swiperInstance && swiperInstance.slides) {
            activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        } else {
            activeSlide = beautySection.querySelector('.main-slider .swiper-slide-active');
        }

        if (!activeSlide) return;

        const variantId = activeSlide.getAttribute('data-variant-id');
        const available = activeSlide.getAttribute('data-available');
        const productImg = activeSlide.getAttribute('data-product');

        if(variantInput && variantId) {
            variantInput.value = variantId; 
            variantInput.setAttribute('value', variantId);
        }

        if(productImg && productImage){
            productImage.src = productImg;
        }

        if(submitBtn && btnText) {
            if (available === 'true') {
                submitBtn.removeAttribute('disabled');
                btnText.innerHTML = 'Add To Cart';
            } else {
                submitBtn.setAttribute('disabled', true);
                btnText.innerHTML = 'Sold Out';
            }
        }
    }

    updateProductData(mainSwiper); // initial call

    /* ---------------------------
       DRAG PROGRESS LOGIC
    ---------------------------- */
    if (dragEl && progressBar) {
        dragEl.addEventListener('pointerdown', (e) => {
            isDragging = true;
            dragEl.setPointerCapture(e.pointerId);
        });

        document.addEventListener('pointermove', (e) => {
            if (!isDragging) return;

            const rect = progressBar.getBoundingClientRect();
            const dragWidth = dragEl.clientWidth;
            const maxMove = rect.width - dragWidth; 

            let x = e.clientX - rect.left - (dragWidth / 2);
            x = Math.max(0, Math.min(x, maxMove));

            dragEl.style.left = `${x}px`;

            const percent = maxMove === 0 ? 0 : x / maxMove;
            const realTotal = mainSwiper.slides.length; 
            const slideIndex = Math.round(percent * (realTotal - 1));

            mainSwiper.slideToLoop(slideIndex);
        });

        document.addEventListener('pointerup', () => {
            isDragging = false;
        });
    }

    /* ---------------------------
       DAWN THEME CART DRAWER LOGIC
    ---------------------------- */
    const productForm = beautySection.querySelector('.beauty_product_form');

    if (productForm) {
        productForm.addEventListener('submit', function (e) {
            e.preventDefault();

            const originalText = btnText.innerHTML;
            btnText.innerHTML = 'Adding...';
            submitBtn.setAttribute('disabled', true);

            const formData = new FormData(productForm);
            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
                const sectionsToRender = cartDrawer.getSectionsToRender().map((s) => s.id);
                formData.append('sections', sectionsToRender.join(','));
            } else {
                formData.append('sections', 'cart-drawer,cart-icon-bubble');
            }
            formData.append('sections_url', window.location.pathname);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then((response) => response.json())
            .then((parsedState) => {
                btnText.innerHTML = originalText;
                submitBtn.removeAttribute('disabled');

                if (parsedState.status) {
                    alert(parsedState.description || 'Error adding product to cart.');
                    return;
                }

                if (cartDrawer) {
                    cartDrawer.classList.remove('is-empty');
                    
                    const drawerInner = cartDrawer.querySelector('.drawer__inner');
                    if (drawerInner) {
                        drawerInner.classList.remove('is-empty');
                    }
                    
                    const drawerHeader = cartDrawer.querySelector('.drawer__header');
                    if (drawerHeader) {
                        drawerHeader.classList.remove('is-empty');
                    }

                    cartDrawer.renderContents(parsedState);
                } else {
                    window.location.href = window.Shopify.routes.root + 'cart';
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                btnText.innerHTML = originalText;
                submitBtn.removeAttribute('disabled');
            });
        });
    }
});
// Beaty Slider Landing Page END